<mat-list-item>
  <mat-icon matListItemIcon
            fontSet="material-icons-outlined">
    {{ activiteit.getType() | zahActiviteitTypeIcon }}
  </mat-icon>
  <div matListItemTitle class="naam">{{ client.getNaam() }}</div>
  <div matListItemLine class="content">{{ activiteit.getContent() }}</div>
  <span matListItemMeta class="meta">{{ activiteit.getTimestamp() | date: 'd MMMM yyyy HH:mm' }}</span>
</mat-list-item>
